// Options for every write of the `token` cookie. The cookie is long-lived (1 year) on
// purpose: it is only a carrier, not the source of truth for validity — readers check
// the JWT's own `exp` (msal.hasValidToken) and renew silently/interactively when it has
// passed. `secure` keeps it off plain-HTTP, `sameSite: 'lax'` blocks CSRF while still
// surviving the top-level AAD return navigation.
// NOTE: httpOnly is intentionally NOT set — the client reads this token (parseJwt /
// Bearer header). Closing that gap needs a server-side/BFF rework, tracked separately.
export const TOKEN_COOKIE_OPTIONS = {
  path: '/',
  maxAge: 60 * 60 * 24 * 365,
  secure: true,
  sameSite: 'lax'
} as const;
